/**
 * Google Analytics Utilities
 * Google Analytics provider'ları için ortak fonksiyonlar
 */

import { sendGTMEvent } from "@next/third-parties/google";

/**
 * DataLayer'a event gönderir (Google Analytics için)
 * @param {string} event - Event adı (veya özel durumlar için object)
 * @param {object} data - Event verisi
 */
export const pushToDataLayer = (event, data) => {
  if (typeof window === "undefined") {
    return;
  }

  // Eğer event bir object ise (örn: { ecommerce: null }), direkt gönder
  if (typeof event === "object") {
    sendGTMEvent(event);
    return;
  }

  // Event string ise, data ile birleştir ve gönder
  sendGTMEvent({
    event,
    ...data,
  });
};
